<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_status === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete === true">ลบบทความเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-2">
          <div class="text-right ma-2">
            <v-btn x-large class="text-center grad-success-bg white--text mobile_btn" to="/articleadd">บทความใหม่</v-btn>
          </div>
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="header" :items="data_list" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.item.created_at }}</td>
                <td>
                  <v-img class="ma-1 rounded" height="128" max-width="128" :lazy-src="img_holder" :src="dataDetail.item.cover_img"></v-img>
                </td>
                <td>{{ dataDetail.item.title }}</td>
                <td>{{ dataDetail.item.user_name }}</td>
                <td>
                  <v-switch class="mt-0 ml-3" color="#86bc3a" @change="changeStatus(dataDetail.item.id, dataDetail.item.status)" v-model="dataDetail.item.status"></v-switch>
                </td>
                <td>
                  <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                    <v-icon>mdi-note-edit-outline</v-icon>
                  </v-btn>
                  <v-btn small height="42" @click="image_remove(dataDetail.item.id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import img_holder from "@/assets/picture.png";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Article_manage",
  data() {
    return {
      loading_page: false,
      alert_status: false,
      alert_delete: false,
      img_holder: img_holder,
      header: [
        {
          text: 'วันที่สร้าง',
          value: 'created_at',
          fixed: true,
          width: '180px',
        },
        {
          text: 'รูปภาพ',
          value: 'cover_img',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หัวเรื่อง',
          value: 'title',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ผู้สร้าง',
          value: 'user_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '250px',
        },
      ],
      data_list: [],
      search: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
    }
  },
  methods: {
    changeStatus(id, status) {
      HTTP.post('/manage-website/articles/status', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_status = true
          setTimeout(() => this.alert_status = false, 3000)
        }
      })
    },
    get_content() {
      this.loading_page = true
      HTTP.post('/manage-website/articles/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.data_list = res.data.object
            }
          })
    },
    getEdit(id) {
      this.$router.push('/articleedit' + '/' + id)
    },
    image_remove(id) {
      Swal.fire({
        title: 'คุณต้องการลบรูปภาพหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/manage-website/articles/delete', {
            id: id
          }).then((res) => {
            if (res.data.success === true) {
              this.get_content()
              this.alert_delete = true
              setTimeout(() => this.alert_delete = false, 3000)
            }
          })
        }
      })
    }
  },
  mounted() {
    this.get_content()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.mobile_btn {
  width: 30%;
}
@media only screen and (max-width: 1180px){
  .mobile_btn {
    width: 40%;
  }
}
@media only screen and (max-width: 500px){
  .mobile_btn {
    width: 100%;
  }
}
</style>
